import { render, staticRenderFns } from "./AwardCriteriaMapping.vue?vue&type=template&id=a9e21a02&scoped=true"
import script from "./AwardCriteriaMapping.vue?vue&type=script&lang=js"
export * from "./AwardCriteriaMapping.vue?vue&type=script&lang=js"
import style0 from "./AwardCriteriaMapping.vue?vue&type=style&index=0&id=a9e21a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e21a02",
  null
  
)

export default component.exports